import React from 'react';
import './App.css';
import FlashcardApp from './FlashcardApp';

function App() {
  return (
    <div className="App">
      <FlashcardApp />
    </div>
  );
}

export default App;